import { Injectable, effect, inject, signal } from '@angular/core';
import { Auth, user } from '@angular/fire/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from './user.service';

/**
 * Admin UI gate: custom claim `admin: true` or Firestore `users/{uid}.role == 'admin'`.
 */
@Injectable({ providedIn: 'root' })
export class AuthClaimsService {
  private auth = inject(Auth);
  private userService = inject(UserService);

  readonly isAdmin = signal(false);
  private readonly currentUser = toSignal(user(this.auth));

  constructor() {
    effect(() => {
      const firebaseUser = this.currentUser();
      const role = this.userService.role();
      if (!firebaseUser) {
        this.isAdmin.set(false);
        return;
      }
      void firebaseUser.getIdTokenResult()
        .then(tokenResult => {
          const fromClaim = tokenResult.claims['admin'] === true;
          const fromRole = role === 'admin';
          this.isAdmin.set(fromClaim || fromRole);
        })
        .catch(() => this.isAdmin.set(role === 'admin'));
    });
  }
}
